import { render } from "./ProductData.vue?vue&type=template&id=fae59a66"
import script from "./ProductData.vue?vue&type=script&lang=js"
export * from "./ProductData.vue?vue&type=script&lang=js"

import "./ProductData.vue?vue&type=style&index=0&id=fae59a66&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__